/* eslint-disable @typescript-eslint/no-explicit-any */

import { ITrackingService } from "./iTracking.service";


export enum TrackingLevel {
    Verbose = 0,
    Information = 1,
    Warning = 2,
    Error = 3,
    Critical = 4
}

export class GlobalTrackingService {
    private trackers: ITrackingService[] = [];

    /**
     * Initialize all trackers.
     * @param {ITrackingService[]} trackers All trackers to be initialized.
     */
    init(trackers: ITrackingService[]) {
        this.trackers = trackers;
        for (const tracker of trackers) {
            tracker.init();
        }
    }

    /**
     * Tracks an exception to all trackers.
     * @param {Error} error The error to track.
     * @param {number} severityLevel Verbose=0, Information=1, Warning=2, Error=3, Critical=4.
     * @param {{ [key: string]: any; }} properties Properties to add for tracking.
     */
    trackException(error: Error, severityLevel: TrackingLevel = TrackingLevel.Error, properties?: { [key: string]: any; }) {
        for (const tracker of this.trackers) {
            tracker.trackException(error, severityLevel, properties);
        }
    }

    /**
     * Tracks an page view to all trackers.
     * @param {string} name The event name.
     * @param {{ [key: string]: any; }} properties Properties to add for tracking.
     */
    trackPageView(name: string, pageType: string, properties?: { [key: string]: any; }) {
        for (const tracker of this.trackers) {
            tracker.trackPageView(name, pageType, properties);
        }
    }

    /**
     * Tracks an event to all trackers.
     * @param {string} name The event name.
     * @param {string} category The category of the event.
     * @param {{ [key: string]: any; }} properties Properties to add for tracking.
     */
    trackEvent(name: string, category: string, properties?: { [key: string]: any; }) {
        for (const tracker of this.trackers) {
            tracker.trackEvent(name, category, properties);
        }
    }

    /**
     * Tracks an client event to all trackers.
     * @param {string} message The message.
     * @param {number} severityLevel Verbose=0, Information=1, Warning=2, Error=3, Critical=4
     * @param {{ [key: string]: any; }} properties Properties to add for tracking.
     */
    trackClientEvent(message: string, severityLevel: TrackingLevel = TrackingLevel.Information, properties?: { [key: string]: any; }) {
        for (const tracker of this.trackers) {
            tracker.trackClientEvent(message, severityLevel, properties);
        }
    }
}

export const globalTrackingService = new GlobalTrackingService();